export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

console.log("API_BASE_URL:", API_BASE_URL);
// ── getToken ─────────────────────────────────────────────────
export function getToken() {
  return localStorage.getItem('fmcc_token');
}

// ── saveToken ────────────────────────────────────────────────
export function saveToken(token) {
  localStorage.setItem('fmcc_token', token);
}

// ── clearToken ───────────────────────────────────────────────
export function clearToken() {
  localStorage.removeItem('fmcc_token');
  localStorage.removeItem('fmcc_user');
}

// ── apiFetch ─────────────────────────────────────────────────
// Wrapper that:
//   1. Adds the base URL automatically
//   2. Adds Authorization header automatically
//   3. Handles JSON parsing
//   4. Throws a readable error if request fails
//
// Usage:
//   const data = await apiFetch('/timesheet/my-week?week_ending=2025-01-04');
//   const data = await apiFetch('/timesheet/entries', { method: 'POST', body: { ... } });
export async function apiFetch(path, options = {}) {
  const token = getToken();

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    body: options.body ? JSON.stringify(options.body) : undefined,
  });

  // Handle CSV/blob responses
  if (options.responseType === 'blob') {
    if (!response.ok) throw new Error(`Request failed: ${response.status}`);
    return response.blob();
  }

  const data = await response.json();

  if (!response.ok) {
    // Redirect to login on 401
    if (response.status === 401) {
      clearToken();
      window.location.href = '/login';
    }
    throw new Error(data.message || `Request failed: ${response.status}`);
  }

  return data;
}
